import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngx-datatable-tree-toggle]'
})
export class DataTableColumnCellTreeToggle {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
